<a class="link proof-email-trigger" title="Pending Emails" (click)="open()">
  <p-overlaybadge [value]="pendingCount.toString()" severity="danger">
    <i class="pi pi-envelope"></i>
  </p-overlaybadge>
  <span class="proof-email-trigger-label">Pending Emails</span>
</a>

<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [style]="{ width: '75vw' }"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  [closeOnEscape]="true"
  [blockScroll]="true"
  appendTo="body"
  styleClass="proof-email-dialog"
  (onHide)="close()">
  <ng-template pTemplate="header">
    <div class="w-100 has-border">
      <h2>Pending Emails</h2>
    </div>
  </ng-template>

  <div class="d-flex justify-content-between align-items-center mb-3 gap-3">
    <span class="proof-email-note">
      Proof notifications are consolidated and sent automatically once daily.
      Use "Send Email" to notify a recipient immediately instead of waiting.
    </span>
    <p-button
      label="Refresh"
      icon="pi pi-refresh"
      size="small"
      [loading]="loading()"
      (click)="refresh()" />
  </div>

  <p-tabs [value]="activeTab()" (valueChange)="activeTab.set($any($event))">
    <p-tablist>
      <p-tab value="queue">Queue</p-tab>
      <p-tab value="history" [disabled]="sending()">History</p-tab>
    </p-tablist>
    <p-tabpanels class="p-0 pt-2">
      <p-tabpanel value="queue" class="p-0">
        <div class="d-flex justify-content-end mb-2">
          <p-button
            label="Send Email"
            icon="pi pi-send"
            size="small"
            [loading]="sending()"
            [disabled]="selectedRecords().length === 0"
            (click)="sendEmail(selectedRecords())" />
        </div>
        <ng-container
          *ngTemplateOutlet="
            grid;
            context: { rows: queue(), isQueue: true }
          "></ng-container>
      </p-tabpanel>
      <p-tabpanel value="history" class="p-0">
        <ng-container
          *ngTemplateOutlet="
            grid;
            context: { rows: history(), isQueue: false }
          "></ng-container>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</p-dialog>

<ng-template #grid let-rows="rows" let-isQueue="isQueue">
  <p-table
    #dt
    stripedRows
    [rowHover]="true"
    [scrollable]="true"
    scrollHeight="calc(100vh - 400px)"
    [size]="'small'"
    [value]="rows"
    [selection]="isQueue ? selectedRecords() : []"
    (selectionChange)="isQueue && selectedRecords.set($any($event))"
    dataKey="id"
    styleClass="table-listing">
    <ng-template pTemplate="header">
      <tr class="table-head">
        <th *ngIf="isQueue" class="proof-email-check">
          <p-tableHeaderCheckbox />
        </th>
        <th pSortableColumn="orderLineItemReference">
          Item <p-sortIcon field="orderLineItemReference" />
        </th>
        <th pSortableColumn="email">
          Recipient Email <p-sortIcon field="email" />
        </th>
        <th>Uploaded by</th>
        <th>Type</th>
        <th pSortableColumn="createdAt" class="proof-email-datetime">
          Created <p-sortIcon field="createdAt" />
        </th>
        <th pSortableColumn="status">Status <p-sortIcon field="status" /></th>
        <th *ngIf="!isQueue" class="proof-email-datetime">Sent</th>
      </tr>
      <tr>
        <th *ngIf="isQueue"></th>
        <th>
          <input
            pInputText
            type="text"
            class="w-100"
            placeholder="Search"
            (input)="
              dt.filter(
                $any($event.target).value,
                'orderLineItemReference',
                'contains'
              )
            " />
        </th>
        <th>
          <input
            pInputText
            type="text"
            class="w-100"
            placeholder="Search"
            (input)="
              dt.filter($any($event.target).value, 'emailSearch', 'contains')
            " />
        </th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th *ngIf="!isQueue"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-record>
      <tr class="p-selectable-row">
        <td *ngIf="isQueue" class="proof-email-check">
          <p-tableCheckbox [value]="record" />
        </td>
        <td>{{ record.orderLineItemReference }}</td>
        <td>
          <div class="d-flex align-items-center gap-2">
            <span class="text-truncate">{{ record.email }}</span>
            @if (record.extraEmails.length) {
              <span
                class="proof-email-more d-inline-flex align-items-center justify-content-center rounded-pill flex-shrink-0"
                tabindex="0"
                tooltipPosition="top"
                tooltipStyleClass="proof-email-tooltip"
                [pTooltip]="record.extraEmails.join('\n')"
                [attr.aria-label]="
                  record.extraEmails.length +
                  ' more recipients: ' +
                  record.extraEmails.join(', ')
                "
                >+{{ record.extraEmails.length }}</span
              >
            }
          </div>
        </td>
        <td>{{ record.uploaderName }}</td>
        <td>{{ record.isResubmission ? "Resubmission" : "New upload" }}</td>
        <td class="proof-email-datetime">
          {{ record.createdAt | date: "MMM d, y, h:mm:ss a" }}
        </td>
        <td>
          <p-tag
            [value]="record.status"
            [styleClass]="
              'proof-email-status rounded-pill ' +
              (record.status === 'Sent'
                ? 'proof-email-status-sent'
                : 'proof-email-status-pending')
            " />
        </td>
        <td *ngIf="!isQueue" class="proof-email-datetime">
          {{ record.sentAt | date: "MMM d, y, h:mm:ss a" }}
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="isQueue ? 7 : 8">No records found.</td>
      </tr>
    </ng-template>
  </p-table>
</ng-template>
